
import { actionCreator } from 'utils';
import * as QuoteTypes from '../types/quoteTypes';

const initState = {
    loading: false,
    error: false,
    view: {
        loading: false,
        error: false,
        data: null,
        sender: null,
        contact: null,
        clone: {
            loading: [],
            error: false,
            success: false,
        },
        status: {
            loading: false,
            error: false,
            success: false,
        },
        cancel: {
            loading: false,
            error: false,
            success: false,
        },
        items: {
            clone: {
                loading: [],
                error: false,
                success: false,
            },
            delete: {
                loading: [],
                error: false,
                success: false,
            },
            checked: [],
        },
    },
    add: {
        quote: {
            loading: false,
            error: false,
            data: null,
        },
        quoteItem: {
            loading: false,
            error: false,
            success: false,
        },
        additionalItem: {
            loading: false,
            error: false,
            success: false,
        },
        favoris: {
            loading: false,
            error: false,
            success: false,
        },
    },
    edit: {
        quote: {
            loading: false,
            error: false,
            success: false,
        },
        quoteItem: {
            loading: false,
            error: false,
            success: false,
        },
    },
    del: {
        favoris: {
            loading: false,
            error: false,
            success: false,
        },
        additionalItem: {
            loading: false,
            error: false,
        },
    },
    neededData: {
        users: [],
        billings: [],
        configurations: [],
        productGroups: [],
    },
};

export default (state = initState, action) => {
    switch (action.type) {
    case QuoteTypes.LOAD_QUOTE:
        return Object.assign({}, state, {
            view: {
                ...state.view,
                loading: true,
                error: false,
            },
        });

    case actionCreator(QuoteTypes.LOAD_QUOTE, 'res'):
        return Object.assign({}, state, {
            view: {
                ...state.view,
                loading: false,
                data: action.data,
            },
        });

    case actionCreator(QuoteTypes.LOAD_QUOTE, 'err'):
        return Object.assign({}, state, {
            view: {
                ...state.view,
                loading: false,
                error: true,
            },
        });

    case QuoteTypes.SET_QUOTE_NEEDED_DATA:
        return Object.assign({}, state, {
            neededData: {
                ...state.neededData,
                ...action.data,
            },
        });

    case QuoteTypes.ADD_NEW_QUOTE:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.quote,
                quote: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.ADD_NEW_QUOTE, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.quote,
                quote: {
                    loading: false,
                    error: false,
                    data: action.data,
                },
            }),
        });

    case actionCreator(QuoteTypes.ADD_NEW_QUOTE, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.quote,
                quote: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case QuoteTypes.CLONE_QUOTE:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                ...state.view,
                clone: {
                    loading: [
                        ...state.view.clone.loading,
                        action.clonedQuoteId,
                    ],
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.CLONE_QUOTE, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                ...state.view,
                clone: {
                    loading: state.view.clone.loading.filter(c => !action.payload.includes(c)),
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(QuoteTypes.CLONE_QUOTE, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                ...state.view,
                clone: {
                    loading: [],
                    error: action.error,
                    success: false,
                },
            }),
        });

    case QuoteTypes.CANCEL_QUOTE:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                cancel: {
                    loading: true,
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.CANCEL_QUOTE, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                cancel: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(QuoteTypes.CANCEL_QUOTE, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                cancel: {
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case QuoteTypes.CHANGE_QUOTE_STATUS:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                status: {
                    loading: true,
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.CHANGE_QUOTE_STATUS, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                status: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(QuoteTypes.CHANGE_QUOTE_STATUS, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                status: {
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case QuoteTypes.EDIT_QUOTE:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                quote: {
                    loading: true,
                    error: false,
                    success: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.EDIT_QUOTE, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                quote: {
                    loading: action.loading,
                    error: false,
                    success: action.success,
                },
            }),
        });

    case actionCreator(QuoteTypes.EDIT_QUOTE, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                quote: {
                    loading: false,
                    error: action.error,
                    success: false,
                },
            }),
        });

    case QuoteTypes.ADD_NEW_QUOTE_ITEM:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.quote,
                quoteItem: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.ADD_NEW_QUOTE_ITEM, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.quote,
                quoteItem: {
                    loading: action.loading,
                    success: action.success,
                    error: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.ADD_NEW_QUOTE_ITEM, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.quote,
                quoteItem: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case QuoteTypes.ADD_QUOTE_ADDITIONAL_ITEM:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.additionalItem,
                additionalItem: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.ADD_QUOTE_ADDITIONAL_ITEM, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.additionalItem,
                additionalItem: {
                    loading: action.loading,
                    success: action.success,
                    error: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.ADD_QUOTE_ADDITIONAL_ITEM, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.additionalItem,
                additionalItem: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case QuoteTypes.DELETE_QUOTE_ADDITIONAL_ITEM:
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.additionalItem,
                additionalItem: {
                    loading: action.data.id,
                    error: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.DELETE_QUOTE_ADDITIONAL_ITEM, 'res'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.additionalItem,
                additionalItem: {
                    loading: false,
                    error: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.DELETE_QUOTE_ADDITIONAL_ITEM, 'err'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.additionalItem,
                additionalItem: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case QuoteTypes.EDIT_QUOTE_ITEM:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.quote,
                quoteItem: {
                    loading: true,
                    success: false,
                    error: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.EDIT_QUOTE_ITEM, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.quote,
                quoteItem: {
                    loading: action.loading,
                    success: action.success,
                    error: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.EDIT_QUOTE_ITEM, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                ...state.edit.quote,
                quoteItem: {
                    loading: false,
                    error: true,
                },
            }),
        });


    case QuoteTypes.LOAD_QUOTES_CONTACT:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                ...state.view,
                contact: {
                    loading: true,
                },
            }),
        });

    case actionCreator(QuoteTypes.LOAD_QUOTES_CONTACT, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                ...state.view,
                contact: action.data,
            }),
        });

    case actionCreator(QuoteTypes.LOAD_QUOTES_CONTACT, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                ...state.view,
                contact: {
                    error: true,
                },
            }),
        });

    case QuoteTypes.LOAD_QUOTES_SENDER:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                ...state.view,
                sender: {
                    loading: true,
                },
            }),
        });

    case actionCreator(QuoteTypes.LOAD_QUOTES_SENDER, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                ...state.view,
                sender: action.data,
            }),
        });

    case actionCreator(QuoteTypes.LOAD_QUOTES_SENDER, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                ...state.view,
                sender: {
                    error: true,
                },
            }),
        });

    case QuoteTypes.CLONE_QUOTE_ITEM:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    clone: {
                        loading: [
                            ...state.view.items.clone.loading,
                            action.clonedItemId,
                        ],
                        error: false,
                        success: false,
                    },
                },
            }),
        });

    case actionCreator(QuoteTypes.CLONE_QUOTE_ITEM, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    clone: {
                        loading: state.view.items.clone.loading.filter(c => !action.payload.includes(c)),
                        success: true,
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(QuoteTypes.CLONE_QUOTE_ITEM, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    clone: {
                        error: true,
                        loading: [],
                    },
                },
            }),
        });

    case QuoteTypes.DELETE_QUOTE_ITEM:
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    delete: {
                        loading: [
                            ...state.view.items.delete.loading,
                            action.quoteItemId,
                        ],
                        error: false,
                        success: false,
                    },
                },
            }),
        });

    case actionCreator(QuoteTypes.DELETE_QUOTE_ITEM, 'res'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    delete: {
                        loading: state.view.items.delete.loading.filter(c => !action.payload.includes(c)),
                        success: true,
                        error: false,
                    },
                },
            }),
        });

    case actionCreator(QuoteTypes.DELETE_QUOTE_ITEM, 'err'):
        return Object.assign({}, state, {
            view: Object.assign({}, state.view, {
                items: {
                    ...state.view.items,
                    delete: {
                        error: true,
                        loading: [],
                    },
                },
            }),
        });

    case QuoteTypes.ADD_NEW_FAVORIS_QUOTE:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.favoris,
                favoris: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.ADD_NEW_FAVORIS_QUOTE, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.favoris,
                favoris: {
                    loading: false,
                    error: false,
                    data: action.data,
                },
            }),
        });

    case actionCreator(QuoteTypes.ADD_NEW_FAVORIS_QUOTE, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                ...state.add.favoris,
                favoris: {
                    loading: false,
                    error: true,
                },
            }),
        });

    case QuoteTypes.DELETE_FAVORIS_QUOTE:
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.favoris,
                favoris: {
                    loading: true,
                    error: false,
                },
            }),
        });

    case actionCreator(QuoteTypes.DELETE_FAVORIS_QUOTE, 'res'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.favoris,
                favoris: {
                    loading: false,
                    error: false,
                    data: action.data,
                },
            }),
        });

    case actionCreator(QuoteTypes.DELETE_FAVORIS_QUOTE, 'err'):
        return Object.assign({}, state, {
            del: Object.assign({}, state.del, {
                ...state.del.favoris,
                favoris: {
                    loading: false,
                    error: true,
                },
            }),
        });

    default:
        return state;
    }
};
